<ul class="footer-list">
	<li><a href="https://bluebillywig.com/" class="rb-a" target="_blank">{{ 'BLUE_BILLYWIG' | translate }}</a></li>
	<li>|</li>
	<li><a (click)="dataProtectionClick.emit(true)" class="rb-a">{{ 'DATA_PROTECTION' | translate }}</a></li>
	<li>|</li>
	<li><a href="https://support.bluebillywig.com" class="rb-a" target="_blank">{{ 'SUPPORT' | translate }}</a></li>
</ul>
